<template>
<div class="chapter">
<div class="inner_page">
<h3 class="h3b"><a id="page_5"></a><a id="ch2"></a><em>Acts of God</em></h3>
<h4 class="h4"><a id="lev1"></a>I. Tornado</h4>
<p class="noindentt">I said the people come inside.</p>
<p class="noindent">They would be safe</p>
<p class="noindent">in the building.</p>
<p class="noindent">So many of those people die.</p>
<p class="noindent">You can see my guilt.</p>
<p class="noindentt">I could see hands</p>
<p class="noindent">to a lady moving.</p>
<p class="noindent">I knew the lady.</p>
<p class="noindent">You can see my guilt.</p>
<p class="noindentt">Sometimes I want to run, to get</p>
<p class="noindent">away from it. I ask forgiveness</p>
<p class="noindent">night and day, I ask it from</p>
<p class="noindent">the cemetery. I can never</p>
<p class="noindent">dream this storm away.</p>
<p class="noindentt">It was over for maybe minutes</p>
<p class="noindent">then it was never over.</p>
<h4 class="h4"><a id="page_6"></a><a id="lev2"></a>II. Lightning</h4>
<p class="noindentt">It pushed me backward, I could see</p>
<p class="noindent">my friends go backward, too,</p>
<p class="noindent">as from a blast, but slowly,</p>
<p class="noindent">very slowly, everything was in</p>
<p class="noindent">a different time.</p>
<p class="noindentt">It burned inside my body.</p>
<p class="noindent">I could feel my hands</p>
<p class="noindent">curl up. My pocket got</p>
<p class="noindent">on fire, I didn’t want</p>
<p class="noindent">to reach in there and take</p>
<p class="noindent">a handful of the hot.</p>
<p class="noindent">My money hurt.</p>
<p class="noindentt">I’m different now forever, put that fact</p>
<p class="noindent">into your book. My hair used to be straight.</p>
<p class="noindent">My eyes—you see? They’re gray as ash.</p>
<p class="noindent">They used to be light blue. You live,</p>
<p class="noindentt">if you’re lucky, but take my word—</p>
<p class="noindentt">it changes how you look.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?8457df48